import { render, staticRenderFns } from "./DeliveryNotesView.vue?vue&type=template&id=2edf9c1b"
import script from "./DeliveryNotesView.vue?vue&type=script&lang=js"
export * from "./DeliveryNotesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports